"use client";

import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

interface BookDialogContextProviderProps {
  children: ReactNode;
}

interface BookDialogContextProps {
  bookDialogOpen: boolean;
  setBookDialogOpen: Dispatch<SetStateAction<boolean>>;
}

export const BookDialogContext = createContext<BookDialogContextProps>({
  bookDialogOpen: false,
  setBookDialogOpen: () => {},
});

export const useBookDialogContext = () => useContext(BookDialogContext);

export default function BookDialogContextProvider({
  children,
}: BookDialogContextProviderProps) {
  const [bookDialogOpen, setBookDialogOpen] = useState<boolean>(false);

  return (
    <BookDialogContext.Provider
      value={{
        bookDialogOpen,
        setBookDialogOpen,
      }}
    >
      {children}
    </BookDialogContext.Provider>
  );
}
